export default {
  // 维持登录缓存时间 1天
  LOGIN_EXPIRE: 24 * 3600 * 1000,
  // 保存账号密码时间 30天
  ACCOUNT_EXPIRE: 30 * 24 * 3600 * 1000,
};
